export default "__VITE_ASSET__HFE3atJz__"